<template>
  <article class="ftc">
    <div class="ftc__top">
      <span class="ftc__id">{{ card.label }}</span>
      <span v-if="card.overdue" class="ftc__badge">{{ overdueBadge }}</span>
      <a
        v-if="card.routeUrl"
        :href="card.routeUrl"
        class="ftc__route"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Маршрут"
        title="Маршрут"
      ><i class="ri-map-pin-line" aria-hidden="true"></i></a>
    </div>
    <div class="ftc__title">{{ card.objectName }}</div>
    <div v-if="card.address" class="ftc__address">{{ card.address }}</div>
    <div class="ftc__meta">
      <span class="ftc__deadline"><span class="ftc__meta-label">Дедлайн</span> {{ card.deadline || '—' }}</span>
      <span class="ftc__paper"><span class="ftc__meta-label">Бумага</span> {{ card.paper === null ? '—' : card.paper }}</span>
    </div>
    <ul v-if="card.works.length" class="ftc__works">
      <li v-for="w in card.works" :key="w.id" class="ftc__work" :class="{ 'ftc__work--done': w.done }">{{ w.title }}</li>
    </ul>
    <div v-if="card.dispatcherComment" class="ftc__comment"><b>Диспетчер.</b> {{ card.dispatcherComment }}</div>
    <button type="button" class="btn btn-success ftc__complete" :disabled="disabled" @click="$emit('complete', card)">Завершить обслуживание</button>
  </article>
</template>

<script>
import { OVERDUE_BADGE } from '@/components/field/fieldTasksLogic';

/** One assigned task (KOP-40 spec §6.4). Dumb: renders an `activeCardModel()` and emits `complete`. */
export default {
  name: 'FieldTaskCard',
  props: {
    card: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    overdueBadge() { return OVERDUE_BADGE; },
  },
};
</script>

<style scoped lang="scss">
.ftc { background: #fff; border: 1px solid #e3e5e1; border-radius: 12px; padding: 12px 14px; display: flex; flex-direction: column; gap: 6px; font-size: 13px; color: #1d221f; }
.ftc__top { display: flex; align-items: center; gap: 8px; min-height: 36px; }
.ftc__id { font-family: SFMono-Regular, Menlo, monospace; font-size: 12px; color: #8b918c; }
.ftc__badge { background: #fbeae5; color: #c0492b; font-size: 10.5px; font-weight: 800; padding: 2px 6px; border-radius: 5px; }
.ftc__route { margin-left: auto; width: 44px; height: 44px; display: inline-flex; align-items: center; justify-content: center; border: 1px solid #e3e5e1; border-radius: 10px; color: #1d221f; font-size: 18px; &:hover { background: #f4f5f1; text-decoration: none; } }
.ftc__title { font-weight: 700; font-size: 15px; }
.ftc__address { color: #8b918c; }
.ftc__meta { display: flex; justify-content: space-between; gap: 12px; background: #f4f5f1; border-radius: 8px; padding: 6px 10px; font-weight: 700; }
.ftc__meta-label { color: #8b918c; font-weight: 400; font-size: 11.5px; margin-right: 4px; }
.ftc__works { list-style: none; padding: 0; margin: 2px 0 0; display: flex; flex-direction: column; gap: 3px; }
.ftc__work { position: relative; padding-left: 16px; &::before { content: ''; position: absolute; left: 2px; top: 6px; width: 8px; height: 8px; border-radius: 50%; background: #c3c8c3; } }
.ftc__work--done::before { background: #17876f; }
.ftc__comment { background: #f4f5f1; border-radius: 8px; padding: 8px 10px; color: #4c524d; b { color: #8b918c; font-weight: 700; } }
.ftc__complete { width: 100%; min-height: 44px; margin-top: 4px; font-weight: 700; }
</style>
